// extracted by mini-css-extract-plugin
module.exports = {"container":"_3C70LZIPydi39Fl2hS_raX","icon":"_2a652Y29pE3SS8b7el9d3i"};